import imageUrlBuilder from "@sanity/image-url";
import type React from "react";
import { useMemo } from "react";
import type { SanityImageCrop, SanityImageHotspot } from "../sanity-schema";

const builder = imageUrlBuilder({
  projectId: "om0huuvj",
  dataset: "production",
});

export const SanityImage: React.FC<
  {
    image: {
      asset?: {
        _ref: string;
        _type: "reference";
      };
      hotspot?: SanityImageHotspot;
      crop?: SanityImageCrop;
      _type: "image";
    };
  } & React.ImgHTMLAttributes<HTMLImageElement>
> = ({ image, ...props }) => {
  const url = useMemo(() => {
    const ref = image.asset?._ref;
    if (!ref) {
      return null;
    }
    const img = builder.image(image).width(1200);
    return img.url();
  }, [image]);

  if (!url) {
    return null;
  }

  // biome-ignore lint/performance/noImgElement: Sanity CMS image with dynamic URL, not suitable for next/image
  return <img {...props} src={url} alt={props.alt ?? ""} />;
};
